import { useState, useEffect } from "react";

const useCarForm = () => {
    const [loading, setLoading] = useState(false);
    const [imageFile, setImageFile] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);

    useEffect(() => {

        if (!imageFile) {
            setPreviewImage(null);
            return;
        }
    
        const url = URL.createObjectURL(imageFile);
        setPreviewImage(url);
        return () => {  
            URL.revokeObjectURL(url);    
        };   
    }, [imageFile]);


    return {
        loading,
        setLoading,

        imageFile,
        setImageFile,
    
        previewImage,
        setPreviewImage,
    };
};

export default useCarForm;